module.exports = __webpack_public_path__ + "static/heart-482de90ac93fb3770a58635a8180a722.png";